import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../api";

// /s/shop-name/deal-name — the clean link a shop hands out for one deal.
const DealByLink = () => {
  const { slug, dealSlug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/deals/by-link/${encodeURIComponent(slug)}/${encodeURIComponent(dealSlug)}`)
      .then((r) => navigate(`/deal/${r.data.id}?src=share`, { replace: true }))
      .catch(() => navigate(`/s/${encodeURIComponent(slug)}`, { replace: true }));
  }, [slug, dealSlug, navigate]);

  return (
    <div className="py-24 flex justify-center" data-testid="deal-by-link">
      <Loader2 className="animate-spin text-muted-foreground" />
    </div>
  );
};

export default DealByLink;
